// src/components/FileUploadSection.jsx
// import React from 'react'; // Removed unused import
import PropTypes from 'prop-types';
import { FileUp, FileText, CheckCircle, Upload } from 'lucide-react';
import { PrimaryButton, SecondaryButton } from '@shared/forms/FormStyles';

const FileUploadSection = ({
  file,
  processingSteps, // Still needed to disable button
  handleFileChange, // Required: Parent function to handle file selection & state resets
  handleUpload,     // Required: Parent function to trigger upload
  setFile           // Required: Parent function to clear the selected file
  // Removed: updateStep, setExtractedData, setError, setSuccessMessage, setSaveErrors
}) => {

  // Removed unused internal handlers: handleFileChangeInternal, handleChangeFileClick
  // The onChange and onClick handlers now directly use the props.
    // The parent's handleFileChange should have already handled other resets if needed,


  return (
    <div className="space-y-6">
      {/* Upload Area */}
      {!file ? (
        <div className="border-2 border-dashed border-huntd-secondary/30 rounded-lg p-8 text-center hover:border-huntd-secondary/50 transition-colors">
          <input
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={handleFileChange} // Directly use the passed-in handler
            className="hidden"
            id="cv-upload"
          />
          <label
            htmlFor="cv-upload"
            className="cursor-pointer flex flex-col items-center"
          >
            <FileUp size={40} className="text-huntd-secondary/50 mb-4" />
            <span className="text-base font-medium text-huntd-primary">
              Drop your CV here or click to browse
            </span>
            <span className="text-sm text-huntd-secondary mt-2">
              Supports PDF, DOC, and DOCX files
            </span>
          </label>
        </div>
      ) : null}

      {/* Selected File Display */}
      {file ? (
        <div className={`flex items-center justify-between p-4 ${processingSteps.complete === 'complete' ? 'bg-huntd-success/10 border-huntd-success/20' : 'bg-white border-huntd-secondary/20'} border rounded-lg`}>
          <div className="flex items-center">
            {processingSteps.complete === 'complete' ? (
              <CheckCircle size={20} className="text-huntd-success mr-2" />
            ) : (
              <FileText size={20} className="text-huntd-secondary mr-2" />
            )}
            <div>
              <p className={`text-base font-medium ${processingSteps.complete === 'complete' ? 'text-huntd-success' : 'text-huntd-primary'}`}>{file.name}</p>
              <p className="text-sm text-huntd-secondary">
                {(file.size / 1024 / 1024).toFixed(2)} MB
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <SecondaryButton onClick={() => setFile(null)}> {/* Directly call setFile(null) */}
              Change File
            </SecondaryButton>
            {processingSteps.complete !== 'complete' ? (
              <PrimaryButton
                onClick={handleUpload}
                disabled={Object.values(processingSteps).some(step => step === 'processing')}
              >
                <Upload size={16} className="mr-2" />
                Process CV
              </PrimaryButton>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};

FileUploadSection.propTypes = {
  file: PropTypes.object,
  processingSteps: PropTypes.object.isRequired, // Needed to disable button
  // error: PropTypes.string, // No longer needed directly
  handleFileChange: PropTypes.func.isRequired, // Parent handles selection and resets
  handleUpload: PropTypes.func.isRequired,     // Parent triggers upload
  setFile: PropTypes.func.isRequired           // Parent handles clearing file state
};

export default FileUploadSection;